import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectedCategoryIds,
  setSelectedCategory,
  updateSelectedCategory,
} from '../../../Redux/CategorySlice';

const CategoryTree = ({ error, data, className, inputDesign }) => {
  const [isOpen, setIsOpen] = useState('');

  const dispatch = useDispatch();

  const catId = useSelector(selectedCategoryIds);

  return (
    <>
      {/* <p className="text-danger">{error}</p> */}
      <ul className={className}>
        {data?.map((cat, index) => {
          const hasChildren = cat?.Children;
          console.log('cat', cat)
          return (
            <li key={cat?.id}>
              <div>
                {inputDesign ? (
                  <Form.Check
                    onChange={(e) => {
                      dispatch(updateSelectedCategory(cat?.id));
                      if (cat?.parentId && !catId?.includes(cat?.parentId)) {
                        dispatch(updateSelectedCategory(cat?.parentId));
                      }

                    }}
                    className='mt-0'
                    type='checkbox'
                    defaultValue=''
                    aria-label='Checkbox for following text input'
                    checked={catId?.includes(cat?.id)}
                  />
                ) : (
                  <Form.Check
                    className='mt-0'
                    type='radio'
                    disabled
                    checked={catId?.includes(cat?.id)}
                    defaultValue=''
                    aria-label='Radio button for following text input'
                    name='category'
                    onChange={(e) => {
                      dispatch(updateSelectedCategory(cat?.id));
                      // updateSelectedCategory
                    }}
                  />
                )}

                <span className='d-flex align-items-center justify-content-between w-100'>
                  {cat?.name}{' '}
                  {isOpen === `${index}${cat?.id}` && hasChildren?.length > 0 && (
                    <i class='ri-arrow-down-s-line' onClick={() => setIsOpen(null)}></i>
                  )}{' '}
                  {`${index}${cat?.id}` !== isOpen && hasChildren?.length > 0 && (
                    <i
                      class='ri-arrow-up-s-line'
                      onClick={() => setIsOpen(`${index}${cat?.id}`)}
                    ></i>
                  )}
                </span>
              </div>
              {hasChildren?.length > 0 && isOpen === `${index}${cat?.id}` && (
                <CategoryTree data={hasChildren?.map(it => ({ ...it, parentId: cat?.id }))} className='product-category' inputDesign={true} />
              )}
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default CategoryTree;

















// import React, { useEffect, useState } from 'react';
// import { Form } from 'react-bootstrap';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   selectedCategoryIds,
//   updateSelectedCategory,
// } from '../../../Redux/CategorySlice';

// const CategoryTree = ({ error, data, className, inputDesign }) => {
//   const [isOpen, setIsOpen] = useState('');
//   const dispatch = useDispatch();
//   const catId = useSelector(selectedCategoryIds);

//   // Check if ANY child (or deeper child) is selected
//   const isAnyChildSelected = (children) => {
//     if (!children) return false;

//     return children.some((child) => {
//       if (catId.includes(child.id)) return true;
//       if (child.Children?.length > 0) return isAnyChildSelected(child.Children);
//       return false;
//     });
//   };

//   return (
//     <>
//       <ul className={className}>
//         {data?.map((cat, index) => {
//           const hasChildren = cat?.Children?.length > 0;

//           // Parent highlight logic
//           const parentHighlighted = hasChildren && isAnyChildSelected(cat.Children);

//           return (
//             <li key={cat?.id}>
//               <div
//                 className="d-flex align-items-start"
//                 style={{
//                   color: parentHighlighted ? 'red' : 'inherit',
//                   fontWeight: parentHighlighted ? '600' : 'normal',
//                 }}
//               >
//                 {/* SELECTABLE ONLY IF NO CHILDREN */}
//                 {hasChildren ? (
//                   <Form.Check
//                     className="mt-0 me-2"
//                     type="radio"
//                     disabled={true}
//                     checked={parentHighlighted} // visual highlight
//                   />
//                 ) : (
//                   <Form.Check
//                     className="mt-0 me-2"
//                     type="checkbox"
//                     checked={catId?.includes(cat?.id)}
//                     onChange={() => {
//                       dispatch(updateSelectedCategory(cat?.id));

//                       if (cat?.parentId && !catId?.includes(cat?.parentId)) {
//                         dispatch(updateSelectedCategory(cat?.parentId));
//                       }
//                     }}
//                   />
//                 )}

//                 {/* CATEGORY NAME + TOGGLE ICON */}
//                 <span className="d-flex align-items-center justify-content-between w-100">
//                   {cat?.name}

//                   {/* Toggle arrows */}
//                   {hasChildren && (
//                     <>
//                       {isOpen === `${index}${cat?.id}` ? (
//                         <i
//                           className="ri-arrow-down-s-line"
//                           onClick={() => setIsOpen(null)}
//                           style={{ cursor: 'pointer' }}
//                         ></i>
//                       ) : (
//                         <i
//                           className="ri-arrow-up-s-line"
//                           onClick={() => setIsOpen(`${index}${cat?.id}`)}
//                           style={{ cursor: 'pointer' }}
//                         ></i>
//                       )}
//                     </>
//                   )}
//                 </span>
//               </div>

//               {/* RECURSIVE CHILDREN */}
//               {hasChildren && isOpen === `${index}${cat?.id}` && (
//                 <CategoryTree
//                   data={cat?.Children?.map((c) => ({
//                     ...c,
//                     parentId: cat?.id,
//                   }))}
//                   className="product-category"
//                   inputDesign={true}
//                 />
//               )}
//             </li>
//           );
//         })}
//       </ul>
//     </>
//   );
// };

// export default CategoryTree;

